/**
 * String Utility Functions
 *
 * Common string manipulation utilities for the AI Scene Chatbot components.
 */

/**
 * Escape HTML special characters to prevent XSS
 * @param text - The text to escape
 * @returns The escaped HTML string
 */
export function escapeHtml(text: string): string {
	return text
		.replace(/&/g, '&amp;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;')
		.replace(/"/g, '&quot;');
}

/**
 * Escape special regex characters in a string
 * @param string - The string to escape
 * @returns The escaped string safe for use in RegExp
 */
export function escapeRegExp(string: string): string {
	return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}
